module.exports = __webpack_public_path__ + "img/0905_grey.86644e94.jpg";